import { BaseHit, Hit } from 'instantsearch.js';
import { Product } from 'shared/types/product';
import { getLocalizationInfo } from 'project.config';
import { PRODUCT_CODE } from 'helpers/constants/attributes';
import { localeMapping } from 'helpers/constants/localeMapping';
import { getPdpUrl } from 'helpers/utils/pdpUrlHelper';

interface ProductHitVariant {
  id: string;
  sku: string;
  images: string[];
  prices: Record<string, { centAmount: number; fractionDigits: number }>;
  isOnStock: boolean;
  productcode?: string;
  // Make sure this is required if expected
  attributes?: {
    'item-code': string;
    'colour': string;
  };
}

interface Slug {
  [key: string]: string;
}
interface ProductHit extends BaseHit {
  productcode?: string; // Fix typo here
  productId: string;
  categories?: any;
  categoryKeys?: any;
  name: any;
  attributesAlgolia?: any;
  matchedVariants?: any;
  masterVariantID: any;
  variants: Array<ProductHitVariant>;
  slug: Slug;
  selectedVariant: any;
}

export const mapProduct = (hit: Hit<BaseHit>, locale: string, searchQuery?: string): Product => {
  const productHit = hit as Hit<ProductHit>;
  const localeKey = localeMapping[locale];

  const { currency, locale: currentLocale } = getLocalizationInfo(locale);
  const slug = (productHit.slug?.[currentLocale.replace('_', '-')] ?? productHit.slug?.[`${localeKey}`])
    ?.toLowerCase()
    ?.replace(/\s/g, '-')
    ?.replace('/', '');
  const masterVariant = productHit?.variants?.filter((variant) => variant.id === productHit?.masterVariantID)?.[0];
  const findSkuByItemCode = (itemCode: string) => {
    const matchingVariant = productHit?.variants?.find((variant: any) =>
      variant?.attributes?.['item-code']?.toLowerCase().includes(itemCode.toLowerCase()),
    );
    return matchingVariant;
  };

  const matchedSku = findSkuByItemCode(searchQuery ?? '') ?? masterVariant ?? productHit?.variants?.[0];

  return {
    productId: productHit?.productId,
    productcode: matchedSku?.attributes?.['item-code'],
    name: productHit?.name?.[currentLocale.replace('_', '-')],
    selectedVariant: matchedSku,
    categories: productHit?.categoryKeys?.[currentLocale.replace('_', '-')]?.map((category: any) => ({
      categoryId: category,
      subCategories: [],
    })),
    variants: productHit?.variants?.map((matchedSku) => ({
      ...matchedSku,
      //price: { ...matchedSku?.prices[currency], currencyCode: currency },
    })),
    _url: getPdpUrl(slug, matchedSku?.sku, matchedSku?.attributes?.colour),
    attributesAlgolia: productHit?.attributes,
  };
};


export const mapFrontasticProductToHits = (productHit: Product, locale: string, searchQuery?: string): Product => {
  const masterVariant = productHit?.variants?.[0]
  return {
      ...productHit,
      productId: productHit?.productId,
      selectedVariant: masterVariant,
      productcode: masterVariant?.attributes?.['product-code']
  };
};

